// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Form and input styles */
.form-container {
    width: 100%;
    margin-bottom: 2rem;
    background: #333;
    padding: 18px 20px;
    border-radius: 10px;
    color: #fff;
    box-sizing: border-box;
}
.input-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 18px;
}
.input-group label {
    margin-bottom: 5px;
    color: #fff;
    font-size: 1rem;
    font-family: 'Monaco', monospace;
}
.full-width {
    width: 100%;
}

/* Select styles for irrigation */
.irrigate-select {
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid #565656;
    background: #565656;
    color: #fff;
    font-size: 1rem;
    margin-right: 12px;
    font-family: 'Monaco', monospace;
}
.custom-days-input {
    width: 65px;
    padding: 8px 8px;
    border-radius: 8px;
    border: 1px solid #ccc;
    font-size: 1rem;
    margin-right: 8px;
    background: #fff;
    color: #333;
    font-family: 'Monaco', monospace;
}
.slider-value {
    margin-left: 14px;
    font-size: 1rem;
    color: #fff;
}

/* Info button style */
.info-button {
    background: none;
    border: none;
    color: #6c63ff;
    font-size: 1.3rem;
    cursor: pointer;
    margin-left: 8px;
    vertical-align: middle;
    transition: color 0.2s;
}
.info-button:hover {
    color: #5146a9;
}

/* FastSettings extra button */
.fastSettings-button {
    background-color: #ffc445 !important;
    color: black !important;
    margin: 8px 0 !important;
}

/* QrReader extra fix (so it stretches 100%) */
.QrReader, .QrReader video {
    width: 100% !important;
    max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/FastActions.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,gCAAgC;AACpC;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,cAAc;AAClB;;AAEA,8BAA8B;AAC9B;IACI,oCAAoC;IACpC,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA,8CAA8C;AAC9C;IACI,sBAAsB;IACtB,eAAe;AACnB","sourcesContent":["/* Form and input styles */\n.form-container {\n    width: 100%;\n    margin-bottom: 2rem;\n    background: #333;\n    padding: 18px 20px;\n    border-radius: 10px;\n    color: #fff;\n    box-sizing: border-box;\n}\n.input-group {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 18px;\n}\n.input-group label {\n    margin-bottom: 5px;\n    color: #fff;\n    font-size: 1rem;\n    font-family: 'Monaco', monospace;\n}\n.full-width {\n    width: 100%;\n}\n\n/* Select styles for irrigation */\n.irrigate-select {\n    padding: 10px 14px;\n    border-radius: 8px;\n    border: 1px solid #565656;\n    background: #565656;\n    color: #fff;\n    font-size: 1rem;\n    margin-right: 12px;\n    font-family: 'Monaco', monospace;\n}\n.custom-days-input {\n    width: 65px;\n    padding: 8px 8px;\n    border-radius: 8px;\n    border: 1px solid #ccc;\n    font-size: 1rem;\n    margin-right: 8px;\n    background: #fff;\n    color: #333;\n    font-family: 'Monaco', monospace;\n}\n.slider-value {\n    margin-left: 14px;\n    font-size: 1rem;\n    color: #fff;\n}\n\n/* Info button style */\n.info-button {\n    background: none;\n    border: none;\n    color: #6c63ff;\n    font-size: 1.3rem;\n    cursor: pointer;\n    margin-left: 8px;\n    vertical-align: middle;\n    transition: color 0.2s;\n}\n.info-button:hover {\n    color: #5146a9;\n}\n\n/* FastSettings extra button */\n.fastSettings-button {\n    background-color: #ffc445 !important;\n    color: black !important;\n    margin: 8px 0 !important;\n}\n\n/* QrReader extra fix (so it stretches 100%) */\n.QrReader, .QrReader video {\n    width: 100% !important;\n    max-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
